import { Component } from '@theme/component';

/**
 * @typedef {Object} ContactToggleRefs
 * @property {HTMLButtonElement} toggle
 */

/**
 * Simple component that hides itself and notifies parent to show the contact copy
 */
class ContactToggle extends Component {
  /** @type {ContactToggleRefs} */
  refs;

  connectedCallback() {
    super.connectedCallback();
  }

  /**
   * Button click handler (declared in Liquid with on:click="/handleToggleClick")
   */
  handleToggleClick(/* event */) {
    // hide this component (inline style - safe and local)
    this.style.display = 'none';

    document.querySelector('.contact-form-copy').classList.add('active');
    document.querySelector('.initial-review-only-desktop').style.display = 'none';
    document.querySelector('booking-confirmation-desktop-component').classList.remove('active');
  }
}

customElements.define('contact-toggle', ContactToggle);
